import { sendCustomEvent } from '@Analytics';
import { AgentFileSource, FeedbackSignal, GeneratedFile } from '@Models';
import { markActedOnLastAnswer } from '../../Helpers/Agents/lastAnswer';
import { sendSignal } from '../../Helpers/Agents/signals';
import { useFileDownload } from './useFileDownload';

// Single download path for every file card (chip, image card, lightbox), agent output and user attachments.
export const useGeneratedFileDownload = (
  conversationId: string,
  timestamp: string,
  file: GeneratedFile,
  source: AgentFileSource = 'generated',
) => {
  const { downloadFile } = useFileDownload();

  const download = () =>
    downloadFile.mutate(
      { conversationId, timestamp, fileName: file.file_name, source },
      {
        onSuccess: () => {
          // `file_type` is a MIME string; the file name can carry client data.
          sendCustomEvent('AGENT_FILE_DOWNLOAD', { fileType: file.file_type, source });
          // Only a download of the agent's output counts as engagement with the answer.
          if (source === 'attachment') return;
          sendSignal(conversationId, timestamp, FeedbackSignal.DOWNLOAD);
          markActedOnLastAnswer(conversationId, timestamp);
        },
      },
    );

  return { download, isPending: downloadFile.isPending, error: downloadFile.error };
};

export default useGeneratedFileDownload;
